/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconContrast = createReactComponent("contrast", "IconContrast", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M12 17a5 5 0 0 0 0 -10v10", key: "svg-1" }]
]);

export { IconContrast as default };
//# sourceMappingURL=IconContrast.js.map
